import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200/50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6 py-10 md:py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <Link
              to="/"
              className="flex items-center gap-2 text-foreground-50 no-underline mb-4"
            >
              <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-500 text-background-50 font-bold text-sm">
                漫
              </div>
              <span className="text-lg font-heading font-bold tracking-wide whitespace-nowrap">
                <span className="text-primary-500">韩漫</span>漫画
              </span>
            </Link>
            <p className="text-foreground-500 text-sm leading-relaxed">
              韩漫漫画网站 —— 您的一站式韩国漫画在线观看平台。免费韩国漫画下拉式阅读，随时随地畅享精彩韩漫内容。
            </p>
          </div>

          <div>
            <h4 className="text-foreground-200 font-semibold mb-4 text-sm">
              快速导航
            </h4>
            <div className="flex flex-col gap-2">
              {[
                { to: "/", label: "首页" },
                { to: "/category/all", label: "漫画分类" },
                { to: "/category/romance", label: "恋爱漫画" },
                { to: "/category/fantasy", label: "奇幻漫画" },
                { to: "/category/action", label: "动作漫画" },
              ].map((item) => (
                <Link
                  key={item.to}
                  to={item.to}
                  className="text-foreground-500 hover:text-primary-500 text-sm transition-colors duration-200 whitespace-nowrap"
                >
                  {item.label}
                </Link>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-foreground-200 font-semibold mb-4 text-sm">
              热门标签
            </h4>
            <div className="flex flex-wrap gap-2">
              {[
                "校园",
                "穿越",
                "悬疑",
                "美食",
                "治愈",
                "冒险",
                "恋爱",
                "BL",
                "搞笑",
                "末世",
              ].map((tag) => (
                <span
                  key={tag}
                  className="px-3 py-1 text-xs rounded-full bg-background-200/70 text-foreground-400 hover:text-primary-500 hover:bg-primary-500/10 transition-colors duration-200 cursor-pointer whitespace-nowrap"
                >
                  {tag}
                </span>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-foreground-200 font-semibold mb-4 text-sm">
              关于我们
            </h4>
            <div className="flex flex-col gap-2">
              <Link
                to="/about"
                className="text-foreground-500 hover:text-primary-500 text-sm transition-colors duration-200 whitespace-nowrap"
              >
                品牌介绍
              </Link>
              <Link
                to="/about"
                className="text-foreground-500 hover:text-primary-500 text-sm transition-colors duration-200 whitespace-nowrap"
              >
                联系方式
              </Link>
              <Link
                to="/about"
                className="text-foreground-500 hover:text-primary-500 text-sm transition-colors duration-200 whitespace-nowrap"
              >
                用户协议
              </Link>
              <Link
                to="/about"
                className="text-foreground-500 hover:text-primary-500 text-sm transition-colors duration-200 whitespace-nowrap"
              >
                隐私政策
              </Link>
            </div>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-200/50 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-foreground-600 text-xs">
            &copy; {new Date().getFullYear()} 韩漫漫画网站. 保留所有权利.
            本站内容仅供学习交流，请支持正版漫画。
          </p>
          <p className="text-foreground-600 text-xs">
            韩漫在线观看 · 漫画韩漫网址 · 免费韩国漫画下拉式
          </p>
        </div>
      </div>
    </footer>
  );
}